import { render } from "./TheFooter.vue?vue&type=template&id=02d3e3d1&scoped=true"
const script = {}

import "./TheFooter.vue?vue&type=style&index=0&id=02d3e3d1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-02d3e3d1"

export default script